import { useMemo, useState } from 'react';
import { useT } from '@/i18n/LanguageContext';

/**
 * <EmployeePicker> — 社員（人）を名前で選ぶ。users（ログイン）ではない。
 * 値は表示名の文字列で持つ（既存の `*_owner` 項目と互換）。
 */
export const EmployeePicker = ({ value = '', employees = [], onChange, testId = 'employee-picker' }) => {
  const { t } = useT();
  const [q, setQ] = useState('');
  const rows = useMemo(() => {
    const needle = q.trim().toLowerCase();
    const list = (employees || []).map((e) => (typeof e === 'string' ? { id: e, name: e } : e));
    return needle ? list.filter((e) => String(e.name || '').toLowerCase().includes(needle)) : list;
  }, [employees, q]);
  return (
    <div data-testid={testId}>
      <select value={value || ''} onChange={(e) => onChange?.(e.target.value)}
        className="w-full h-10 mt-1 rounded-md border border-zinc-200 bg-white px-3 text-sm outline-none focus:border-teal-400"
        data-testid={`${testId}-select`}>
        <option value="">{t('reg.notSet')}</option>
        {value && !rows.some((e) => e.name === value) && <option value={value}>{value}</option>}
        {rows.map((e) => <option key={e.id || e.name} value={e.name}>{e.name}</option>)}
      </select>
      {/* 長い名簿のときだけ絞り込みを出す（短い名簿で欄を増やさない） */}
      {(employees || []).length > 12 && (
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('reg.filterByName')}
          className="mt-1 w-full h-8 rounded-md border border-zinc-200 px-2 text-xs outline-none focus:border-teal-400"
          data-testid={`${testId}-filter`} />
      )}
    </div>
  );
};

export default EmployeePicker;
